import * as Sentry from "@sentry/browser";
import { OnboardingTodo } from "../Todos.constants";

// adapted from optinode/webserver/manager/enums.py
export function getOnboardingTodoLabel(
  onboardingTodo: OnboardingTodo,
  year: number
) {
  switch (onboardingTodo) {
    case OnboardingTodo.KONFIGURATION_PRUEFEN:
      return "Konfiguration prüfen";
    case OnboardingTodo.MESSKONZEPT_UND_ZAEHLERKONFIGURATION_DATEN_VERVOLLSTAENDIGEN:
      return "Messkonzept und Zählerkonfiguration Daten vervollständigen";
    case OnboardingTodo.AUFGABENLISTE_MIT_REGULATORISCHEN_PFLICHTEN_ANLEGEN:
      return "Aufgabenliste mit regulatorischen Pflichten anlegen";
    case OnboardingTodo.REGULATORISCHE_DATEN_VERVOLLSTAENDIGEN:
      return "Regulatorische Daten vervollständigen";
    case OnboardingTodo.HISTORISCHE_MESSDATEN_AUS_UNTERMESSSYSTEMEN_BEREITSTELLEN:
      return `Historische Messdaten für ${year} aus Untermesssystemen bereitstellen`;
    case OnboardingTodo.HISTORISCHE_MESSDATEN_AUS_UNTERMESSSYSTEMEN_INTEGRIEREN:
      return `Historische Messdaten für ${year} aus Untermesssystemen integrieren`;
    case OnboardingTodo.VOLLMACHT_FUER_VERMARKTER_BEREITSTELLEN:
      return "Vollmacht für Datenimport bereitstellen";
    case OnboardingTodo.VOLLMACHT_FUER_MSB_BEREITSTELLEN:
      return "Vollmacht für MSB bereitstellen";
    case OnboardingTodo.HISTORISCHE_MSB_DATEN_INTEGRIEREN:
      return `Historische MSB-Daten integrieren für ${year}`;
    case OnboardingTodo.KONTINUIERLICHER_MSB_DATENEMPFANG_EINRICHTEN:
      return "Kontinuierlicher MSB-Datenempfang einrichten";
    case OnboardingTodo.KONTINUIERLICHER_MESSDATENEMPFANG_AUS_UNTERMESSSYSTEMEN_EINRICHTEN:
      return "Kontinuierlicher Messdatenempfang aus Untermesssystemen einrichten";
    case OnboardingTodo.MESS_UND_BILANZIERUNGSKONZEPT_ERSTELLEN:
      return "Mess- und Bilanzierungskonzept erstellen";
    case OnboardingTodo.LIEFERKONDITIONEN_HINTERLEGEN_STROMLIEFERUNG_UND_ABRECHNUNG:
      return "Lieferkonditionen hinterlegen / Stromlieferung und Abrechnung";
    case OnboardingTodo.DIREKTVERMARKTUNGSVERTRAEGE_HINTERLEGEN:
      return "Vermarktungsverträge hinterlegen";
    case OnboardingTodo.P6_VERTRAEGE_HINTERLEGEN:
      return "Paragraph 6 Verträge hinterlegen";
    default:
      Sentry.captureMessage(
        `Unknown onboarding todo: ${onboardingTodo} for year ${year}`
      );
      return "Unbekannte Aufgabe";
  }
}
